/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dnd-html5-backend/~/lodash/_freeGlobal.js
 ** module id = 1014
 ** module chunks = 0
 **/